import React from 'react';

export default function RankingReferenceLabel(props) {
    const {
        fill, value, textAnchor,
        fontSize, viewBox, dy, dx,
    } = props;
    let x = 30- (value.toString().length*5);
    const y = viewBox.y + 3;
    return (
        <text
            x={x} y={y}
            dy={dy}
            dx={dx}
            fill={fill}
            fontSize={fontSize || 10}
            fontWeight={600}
            textAnchor={textAnchor}>
            {value}
        </text>
    )
}
